export enum FilterComponentType {
  MULTI_SELECT = 'multiSelect',
  SINGLE_SELECT = 'singleSelect',
  TOGGLE_FILTER = 'toggleFilter',
}

export type FilterItem = {
  type: FilterComponentType;
  items: { label: string; value: string; isSectionItem?: boolean }[];
  label: string;
};

export type FilterToggleItem = {
  type: FilterComponentType;
  checked: boolean;
  label: string;
};

export type FilterValues = {
  [key: string]: {
    selectedValues: string[];
  };
};

export type Filters = { [key: string]: FilterItem | FilterToggleItem };
